// extracted by mini-css-extract-plugin
module.exports = {"infiniteLoader":"InfiniteLoader_infiniteLoader__3uXNH","infiniteLoaderBar":"InfiniteLoader_infiniteLoaderBar__TI6Td"};